import { Component, Input, OnInit } from '@angular/core';
import { IAccount } from '../../../store/models/account.model';
import { ISelectItem } from '../../../store/models/select.model';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-configure-reports-dialog',
  templateUrl: './configure-reports-dialog.component.html',
  styleUrls: ['./configure-reports-dialog.component.scss'],
})
export class ConfigureReportsDialogComponent implements OnInit {

  @Input() account: IAccount;

  @Input() inputForm: FormGroup;

  reportItems: ISelectItem[] = [
    {
      label: 'Disabled',
      value: 0,
    },
    {
      label: 'Contacts only',
      value: 1,
    },
    {
      label: 'Contacts and closer',
      value: 2,
    },
    {
      label: 'Closer only',
      value: 3,
    },
  ];

  constructor() {
  }

  ngOnInit(): void {
    if (this.inputForm) {
      this.inputForm.addControl('report_toggle', new FormControl(this.account.report_status, [Validators.required]));
    }
  }

}
